import { DataBean } from "../DataBean";

export class KpiConstantTypes extends DataBean {



    public async getKpiConstantTypes(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getKpiConstantTypes_Number", [id]);
    }

}
